import { cn } from '../../lib/cn';
import type { FBASnapshotRow } from '../../supplychain/framework';

type Props = { snapshot?: FBASnapshotRow[] };

export function FBACommandCenterPanel({ snapshot = [] }: Props) {
  return (
    <div className="grid gap-2 grid-cols-2 sm:grid-cols-3">
      {snapshot.map((s) => (
        <div
          key={s.metric}
          className={cn(
            'rounded-lg border p-3',
            s.alert
              ? 'border-error-200 bg-error-50 dark:border-error-900 dark:bg-error-950'
              : 'border-slate-200 dark:border-slate-700',
          )}
        >
          <p className="text-xs text-slate-500">{s.metric}</p>
          <p className={cn('mt-1 text-sm font-semibold', s.alert ? 'text-error-700 dark:text-error-300' : '')}>
            {s.value}
          </p>
        </div>
      ))}
    </div>
  );
}
